import casosImage from "@/assets/casos-screenshot.png";

export default function HeroCasos() {
  return (
    <div className="py-16 md:py-32 flex items-center justify-center relative px-4 md:px-20 overflow-hidden">
      <div className="w-full max-w-7xl mx-auto">
        {/* Título */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-4xl font-semibold text-foreground">
            Gerencie seus casos com IA<br />
            <span className="text-4xl md:text-[6rem] font-bold mt-1 leading-none bg-gradient-to-r from-primary to-primary/60 bg-clip-text text-transparent">
              Organização Total
            </span>
          </h2>
        </div>

        {/* Container com borda e sombra */}
        <div className="max-w-screen-xl mx-auto">
          <div className="relative mt-16">
            {/* Card da imagem com header estilo macOS */}
            <div className="relative rounded-lg bg-gray-900/70 dark:bg-gray-900/70 backdrop-blur-md overflow-hidden ring-1 ring-slate-200/30 dark:ring-white/20">
              {/* Header com círculos coloridos */}
              <div className="bg-gradient-to-b from-gray-800/90 to-gray-800/60 px-4 py-3 flex items-center gap-2">
                <div className="flex items-center gap-2">
                  <span className="w-3 h-3 rounded-full bg-[#ff605c]"></span>
                  <span className="w-3 h-3 rounded-full bg-[#ffbd44]"></span>
                  <span className="w-3 h-3 rounded-full bg-[#00ca4e]"></span>
                </div>
              </div>
              
              {/* Container da imagem */}
              <div className="relative p-[0.3rem]">
                <div className="w-full h-[25rem] md:h-[75rem] rounded-md flex items-center justify-center bg-gray-900/50">
                  <img 
                    src={casosImage} 
                    alt="Sistema de gerenciamento de casos" 
                    className="w-full h-full object-contain rounded-md" 
                    draggable={false} 
                  />
                </div>
                
                {/* Fade transparente na base */}
                <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-background via-background/50 to-transparent pointer-events-none rounded-md" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}